window.$ = window.jQuery = require('jquery');

require('./bootstrap');
require('./nCommon');
require('./libs/anchorScroll');

window.lightbox = require('lightbox2');

lightbox.option({
    'resizeDuration': 200,
    'wrapAround': true
});

//require('owl.carousel');

(function ( $ ) {

    $.fn.rate = function( options ) {

        let $self     = $(this);
        let settings = $.extend({
            url : '#',
            tag : 'Haz clic para puntuar',

        }, $self.data(), options );

        $self.on('mouseenter', 'i', function (e) {

            let $el   = $(this),
                label = $el.data('label');

            $self.children('.rate-selector-x .tag').text(label);
        });

        $self.on('mouseleave', 'i', function (e) {

            $self.children('.rate-selector-x .tag').text(settings.tag);
        });

        $self.on('click', 'i', function (e) {

            let $el  = $(this),
                rate = $el.data('rate');

            window.location.href = settings.url + '?rate=' + rate;
        });
    };

}( jQuery ));
